import { useEffect, useState } from 'react';
import queryString from 'query-string';

export const WEBVIEW_PLATFORM_KEY = '__zeta--is-webview';

export function WebViewProvider({ children, win = window }) {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const { webview } = queryString.parse(win.location.search);
    if (webview) {
      win.localStorage.setItem(WEBVIEW_PLATFORM_KEY, webview);
    }
    setLoaded(true);
  }, []);

  return loaded ? children : null;
}

export const webViewPlatform = () => localStorage.getItem(WEBVIEW_PLATFORM_KEY);
export const isWebView = () => !!webViewPlatform();
